import { isSafari, isChrome, isEDGE } from '@ts/utils/browser';
import { Analytics } from '..';

export type QuickPayLabel = 'Apple Pay' | 'Google Pay' | 'Microsoft Pay' | 'Unknown';

export default function quickPay(self: Analytics) {
    let label: QuickPayLabel;
    const getLabel = () => {
        if (label !== undefined) {
            return label;
        }

        return (label = (() => {
            if (isSafari()) {
                return 'Apple Pay';
            }
            if (isChrome()) {
                return 'Google Pay';
            }
            if (isEDGE()) {
                return 'Microsoft Pay';
            }
            return 'Unknown';
        })());
    };

    const dispatchEvent = (
        action:
            | 'Displayed Button'
            | 'Transaction Started'
            | 'Transaction Successed'
            | 'Transaction Failed'
    ) => {
        self.DataLayerEvent({
            action,
            category: 'Quick Payment',
            label: getLabel(),
            nonInteraction: true,
        });

        return self;
    };

    return {
        get label() {
            return getLabel();
        },
        displayButton() {
            return dispatchEvent('Displayed Button');
        },
        transactionStart() {
            return dispatchEvent('Transaction Started');
        },
        transactionSuccessed() {
            return dispatchEvent('Transaction Successed');
        },
        transactionFailed() {
            return dispatchEvent('Transaction Failed');
        },
    };
}
